import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';

interface GitHubConfiguredRouteProps {
  children: React.ReactNode;
}

/**
 * Guards routes that require the GitHub App to be installed.
 * Checks user.installation_id — set by the GitHub webhook after the user installs the app.
 */
export const GitHubConfiguredRoute: React.FC<GitHubConfiguredRouteProps> = ({ children }) => {
  const user = useSelector((state: RootState) => state.auth.user);

  if (!user?.installation_id) {
    return <Navigate to="/onboarding/github-install" replace />;
  }

  return <>{children}</>;
};
